// import MaskedInput from 'react-text-mask'
// import { makeTelMask, isDateValid } from './common'
// import { history } from './history'
import { useState } from 'react'

import CheckboxListItem from "./CheckboxListItem"
import MandatoryField from "./MandatoryField"

const canSubmit = (data) => {
  // console.log('Checking can submit', data)
  let result = 
    !!data.altura && data.altura.trim() !== ''
  return result
}

const FormPage4 = (props) => {
const data = props.formData
const [valid, setValid] = useState(false)
// console.log('Form page 2 here', props)

setTimeout(() => setValid(canSubmit(data), 1))

  return (

<>
<form className="form"
  style={{
  alignItems: 'center'
}}>

<div className="form-header">Suas características</div>

<div className="form-field-group">
  <fieldset name="cabelo">
    <legend>Cabelo</legend>
  <div className="form-field-group" style={{marginTop: '8px'}}>
  Comprimento:
  <select name="cabeloComprimento"
    value={!!data.cabeloComprimento ? data.cabeloComprimento : '-'}
    onChange={((e) => {
      props.setForm({cabeloComprimento: e.target.value})
    })}>
      <option value='-'></option>
      <option value='careca'>Careca/raspado</option>
      <option value='curto'>Curto</option>
      <option value='médio'>Médio</option>
      <option value='longo'>Longo</option>
    </select>
  </div>

  <div className="form-field-group">
  Tipo:
  <select name="cabeloTipo"
    value={!!data.cabeloTipo ? data.cabeloTipo : '-'}
    onChange={((e) => {
      props.setForm({cabeloTipo: e.target.value})
    })}>
      <option value='-'></option>
      <option value='liso'>Liso</option>
      <option value='cacheado'>Cacheado</option>
      <option value='afro'>Afro</option>
      <option value='outros'>Outros</option>
    </select>
  </div>

  <div className="form-field-group">
  Cor:
  <select name="cabeloCor"
    value={!!data.cabeloCor ? data.cabeloCor : '-'}
    onChange={((e) => {
      props.setForm({cabeloCor: e.target.value})
    })}>
      <option value='-'></option>
      <option value='loiro'>Loiro</option>
      <option value='ruivo'>Ruivo</option>
      <option value='castanho claro'>Castanho claro</option>
      <option value='castanho escuro'>Castanho escuro</option>
      <option value='preto'>Preto</option>
      <option value='grisalho'>Grisalho</option>
      <option value='outros'>Outros</option>
    </select>
  </div>


  </fieldset>
  
</div>


<div className="form-field-group">
  Etnia:
  <select name="etnia" value={!!data.etnia ? data.etnia : '-'}
    onChange={((e) => {
      props.setForm({etnia: e.target.value})
    })}>
      <option value='-'></option>
      <option value='branca'>Branca</option>
      <option value='indígena'>Indígena</option>
      <option value='oriental'>Oriental</option>
      <option value='preta'>Preta</option>
    </select>
</div>

<div className="form-field-group">
  Manequim:
  <input type="number" name="manequim" className="form-text"
    value={data.manequim ? data.manequim : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   manequim: e.target.value
      // }
      // this.setState({formData})
      props.setForm({manequim: e.target.value})
    })}
  />
</div>

<div className="form-field-group">
  Sapato:
  <input type="number" name="sapato" className="form-text"
    value={data.sapato ? data.sapato : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   sapato: e.target.value
      // }
      // this.setState({formData})
      props.setForm({sapato: e.target.value})
    })}
  />
</div>

<div className="form-field-group">
  <MandatoryField title='Altura (cm):' />
  <input type="number" name="altura" className="form-text"
    value={data.altura ? data.altura : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   altura: e.target.value
      // }
      // this.setState({formData})
      props.setForm({altura: e.target.value})
      setValid(canSubmit({...data, altura: e.target.value}))

    })}
  />
</div>

<div className="form-field-group">
  Cintura (cm):
  <input type="number" name="cintura" className="form-text"
    value={data.cintura ? data.cintura : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   cintura: e.target.value
      // }
      // this.setState({formData})
      props.setForm({cintura: e.target.value})
    })}
  />
</div>

<div className="form-field-group">
  Quadril (cm):
  <input type="number" name="quadril" className="form-text"
    value={data.quadril ? data.quadril : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   quadril: e.target.value
      // }
      // this.setState({formData})
      props.setForm({quadril: e.target.value})
    })}
  />
</div>

<div className="form-field-group">
  Busto (cm):
  <input type="number" name="busto" className="form-text"
    value={data.busto ? data.busto : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   busto: e.target.value
      // }
      // this.setState({formData})
      props.setForm({busto: e.target.value})
    })}
  />
</div>

<div className="form-field-group">
  Enquadra-se em nosso casting Plus Size?
  <select name="plusSize" className="form-text"
    value={data.plusSize ? data.plusSize : 'não'}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   plusSize: e.target.value
      // }
      props.setForm({plusSize: e.target.value})
    })}>
    <option value="-"></option>
    <option value="não">Não</option>
    <option value="sim">Sim</option>
  </select>
</div>

<div className="form-field-group">
  Enquadra-se em nosso casting PCD?
  <select name="pcd" className="form-text"
    value={data.pcd ? data.pcd : 'não'}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   pcd: e.target.value
      // }
      props.setForm({pcd: e.target.value})
    })}>
    <option value="-"></option>
    <option value="não">Não</option>
    <option value="sim">Sim</option>
  </select>

  {data.pcd === 'sim' && (
    <div className="form-sub-field">
    Qual(is) deficiência(s) possui?
    <div className="form-list-box">
      <CheckboxListItem 
        title="Física"
        checked={!!data.deficiencias && data.deficiencias['física']}
        onPress={() => {
          let deficiencias = {...data.deficiencias}
          deficiencias['física'] = !deficiencias['física']
          // let formData = {
          //   ...data,
          //   deficiencias
          // }
          props.setForm({deficiencias})
        }}
        noBorder={false}
      />
      <CheckboxListItem 
        title="Visual"
        checked={!!data.deficiencias && data.deficiencias['visual']}
        onPress={() => {
          let deficiencias = {...data.deficiencias}
          deficiencias['visual'] = !deficiencias['visual']
          // let formData = {
          //   ...data,
          //   deficiencias
          // }
          props.setForm({deficiencias})
        }}
        noBorder={false}
      />
      <CheckboxListItem 
        title="Auditiva"
        checked={!!data.deficiencias && data.deficiencias['auditiva']}
        onPress={() => {
          let deficiencias = {...data.deficiencias}
          deficiencias['auditiva'] = !deficiencias['auditiva']
          // let formData = {
          //   ...data,
          //   deficiencias
          // }
          props.setForm({deficiencias})
        }}
        noBorder={false}
      />
      <CheckboxListItem 
        title="Intelectual"
        checked={!!data.deficiencias && data.deficiencias['intelectual']}
        onPress={() => {
          let deficiencias = {...data.deficiencias}
          deficiencias['intelectual'] = !deficiencias['intelectual']
          // let formData = {
          //   ...data,
          //   deficiencias
          // }
          props.setForm({deficiencias})
        }}
        noBorder={false}
      />
      {/* <CheckboxListItem 
        title="Outras"
        checked={!!data.deficiencias && data.deficiencias['outras']}
        onPress={() => {
          let deficiencias = {...data.deficiencias}
          deficiencias['outras'] = !deficiencias['outras']
          let formData = {
            ...data,
            deficiencias
          }
          props.setForm(formData)
        }}
        noBorder={false}
      /> */}
    </div>
  </div>
  )}


  {data.pcd === 'sim' && (
    <div className="form-sub-field">
    Obs:
    <input type="text" name="deficienciaObs" className="form-text"
    // style={{marginLeft: '8px'}}
    value={data.deficienciaObs ? data.deficienciaObs : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   Obs: e.target.value
      // }
      // this.setState({formData})
      props.setForm({deficienciaObs: e.target.value})
    })}
  />
  </div>
  )}

</div>


<div className="form-field-group">
  O que mais você gostaria de nos contar sobre você?
  <input type="text" name="quadril" className="form-text"
    value={data.oQueMais ? data.oQueMais : ''}
    onChange={((e) => {
      props.setForm({oQueMais: e.target.value})
    })}
  />
</div>



<div className="form-send-row">
<button
  // onClick={() => history.goBack()}
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  className="login-button"
  onClick={() => props.onPrev()}
>{`${'< Voltar'}`}
</button>
<button
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  disabled={!valid}
  className="login-button"
  onClick={() => props.onNext()}
>{`${'Continuar >'}`}</button>
</div>
{/* {
!!this.state.error &&
<div className="login-error">{this.state.error}</div>
} */}
</form>
</>
)
}

export default FormPage4
